<template>
	<div class="main-table1">
		<div class="fx-title">
			<p>售后商品清单</p>
		</div>
		<div class="main-table-box">
			<div style="display:flex">
				<el-button type="primary" size='small' class="fx-big-btn valet-add-btn" plain @click="addGoods" :disabled="!acountValue && !afterSaleId">添加售后商品</el-button>
			</div>
			<el-table
				class="grid-content"
				:data="tableData"
				border
			>
				<el-table-column
					prop="pName"
					label="商品名称"
					align="center"
					min-width="110">
					<template slot-scope="scope">
						<div class="pname-box">
							<div v-if="scope.row.giftFlag" class="giftLogo">赠</div>
							<div v-if="scope.row.newFlag" class="giftLogo">新</div>
							<div :title="scope.row.pName">{{scope.row.pName}}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="pCode"
					label="商品编号"
					align="center">
				</el-table-column>
				<el-table-column
					prop="matchcode"
					label="第三方编号"
					align="center">
				</el-table-column>
				<el-table-column
					prop="spec"
					label="规格"
					align="center">
				</el-table-column>
				<el-table-column
					prop="price"
					label="单价"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.price}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="realMoney"
					label="实付额"
					align="center">
				</el-table-column>
				<el-table-column
					prop="spec"
					label="收发详情"
					align="center">
					<template slot-scope="scope">
						<div>订单:{{scope.row.itemQuantity}}</div>
						<div :style="scope.row.itemQuantity !== scope.row.sendCount ? 'color:red' : ''">发货:{{scope.row.sendCount}}</div>
						<div :style="scope.row.getCount !== scope.row.sendCount ? 'color:red' : ''">实收:{{scope.row.getCount}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="afterSaleQuantity"
					label="售后数量"
					align="center">
					<template slot-scope="scope">
						<el-input v-model="scope.row.afterSaleQuantity" @input="quantityInput(scope.row)" @blur="quantityBlur(scope.$index)" :class="+scope.row.afterSaleQuantity > +scope.row.getCount ? 'red-class' : ''" class="filter-input" size="mini"></el-input>
					</template>
				</el-table-column>
				<el-table-column
					prop="afterSaleMoney"
					label="售后金额"
					min-width="100"
					align="center">
					<template slot-scope="scope">
						<div style="display:flex;align-items:center">
							<el-input v-model="scope.row.afterSaleMoney" @input="afterMoneyInput(scope.row)" @blur="afterMoneyBlur(scope.$index)" :class="+scope.row.afterSaleMoney > +scope.row.realMoney ? 'red-class' : ''" style="margin-right: 5px;" size="mini"></el-input>元
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="otherMoney"
					min-width="100"
					label="额外费用"
					align="center">
					<template slot="header">
						<div>额外费用
							<el-tooltip class="item" effect="dark" content="额外费用不作为退款费用" placement="top-start">
								<img src="~/images/icon/tooltip-icon.png" style="display: inline-block;cursor:pointer">
							</el-tooltip>
						</div>
					</template>
					<template slot-scope="scope">
						<div style="display:flex;align-items:center">
							<el-input v-model="scope.row.otherMoney" @input="otherMoneyInput(scope.row)" @blur="otherMoneyBlur(scope.$index)" :class="+scope.row.otherMoney > +scope.row.realMoney ? 'red-class' : ''" style="margin-right: 5px;" size="mini"></el-input>元
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="afterSaleTypeId"
					min-width="120"
					label="售后分类"
					align="center">
					<template slot="header">
						<div>售后分类<span class="head-add" @click="showManage(0)">添加</span></div>
					</template>
					<template slot-scope="scope">
						<el-select v-model="scope.row.afterSaleTypeId" class="select-input" size='small' @focus="afterFocus(scope.$index, scope.row.afterSaleTypeId)" @change="afterSaleChange(scope.$index, scope.row.afterSaleTypeId)" filterable>
							<el-option v-for="item in afterSaleList" :value="item.id" :label="item.value" :key="item.id" :filter="item.disabledflag !== 1" :disabled="item.disabledflag === 1"></el-option>
						</el-select>
					</template>
				</el-table-column>
				<el-table-column
					prop="dealTypeId"
					min-width="120"
					label="处理方式"
					align="center">
					<template slot="header">
						<div>处理方式<span class="head-add" @click="showManage(2)">添加</span></div>
					</template>
					<template slot-scope="scope">
						<el-select v-model="scope.row.dealTypeId" class="select-input" size='small' @change="dealChange(scope.$index, scope.row.dealTypeId)" filterable>
							<el-option v-for="item in dealList" :value="item.id" :label="item.value" :key="item.id" :disabled="item.disabledflag === 1"></el-option>
						</el-select>
					</template>
				</el-table-column>
				<el-table-column
					prop="deptId"
					min-width="120"
					label="责任部门"
					align="center">
					<template slot="header">
						<div>责任部门<span class="head-add" @click="showManage(1)">添加</span></div>
					</template>
					<template slot-scope="scope">
						<el-select v-model="scope.row.deptId" class="select-input" size='small' @change="deptChange(scope.$index, scope.row.deptId)" filterable>
							<el-option v-for="item in deptList" :value="item.id" :label="item.value" :key="item.id" :disabled="item.disabledflag === 1"></el-option>
						</el-select>
					</template>
				</el-table-column>
				<el-table-column
					prop="memo"
					label="原因备注"
					align="center">
					<template slot-scope="scope">
						<el-input v-model="scope.row.memo" size="mini" maxlength="200" placeholder="不超过200字"></el-input>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<el-button type='text' size="mini" @click="deleteSingle(scope.$index)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="goods-total">
			<div><span>售后总品项：</span>{{tableData.length}}</div>
			<div><span>售后总数量：</span>{{totalNum}}</div>
			<div><span>售后总金额：</span>￥{{totalMoney}}</div>
			<!-- <div><span>运费：</span><el-input type="number" v-model="freight" @blur="onBlur" :disabled="tableData.length === 0" class="filter-input" size="mini"></el-input></div> -->
			<div><span>额外费用合计金额：</span>￥{{totalOtherMoney}}</div>
		</div>
		<el-dialog
			title="添加售后商品"
			:visible.sync="dialogVisible"
			class="dialog-title"
			width="1200px"
			@close='dialogClose'
			@open='search'
			:close-on-click-modal="false">
			<div class="dialog-body">
				<div class="filters-container">
					<div class="input-box">
						<span>商品名称/编号：</span>
						<el-input
							v-model="productName"
							placeholder="请输入商品名称/编号/第三方编号"
							size="small"
							clearable
							@keyup.enter.native="search">
						</el-input>
					</div>
					<el-button size="small" type="primary" class="btn fx-btn" @click="search">查询</el-button>
					<el-button size="small" plain class="btn fx-btn" @click="clear">清空</el-button>
				</div>
				<div class="filters-container">订单编号：<span class="order-code" @click="goOrderDetail">{{orderobj.orderNumber}}</span></div>
				<div class="filters-container" v-if="orderobj.memo">整单备注：{{orderobj.orderMemo}}</div>
				<el-table
					class="grid-content"
					:data="tableData2"
					border
					max-height="450"
					@selection-change="selectionChangeHandle"
					ref="DataTable"
				>
					<el-table-column
						type="selection"
						align="center"
						width="55">
					</el-table-column>
					<el-table-column
						prop="pName"
						label="商品名称"
						align="center">
						<template slot-scope="scope">
							<div  class="pname-box">
								<div v-if="scope.row.giftFlag" class="giftLogo">赠</div>
								<div v-if="scope.row.newFlag" class="giftLogo">新</div>
								<div :title="scope.row.pName">{{scope.row.pName}}</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="pCode"
						label="商品编号"
						align="center">
					</el-table-column>
					<el-table-column
						prop="matchcode"
						label="第三方编号"
						align="center">
					</el-table-column>
					<el-table-column
						prop="spec"
						label="规格"
						align="center">
					</el-table-column>
					<el-table-column
						prop="price"
						label="单价"
						align="center">
						<template slot-scope="scope">
							<div>￥{{scope.row.price}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="itemQuantity"
						label="订货数"
						align="center">
					</el-table-column>
					<el-table-column
						prop="sendCount"
						label="实发数"
						align="center">
					</el-table-column>
					<el-table-column
						prop="getCount"
						label="实收数"
						align="center"
						width="115">
					</el-table-column>
					<el-table-column
						prop="productmemo"
						label="备注"
						align="center">
					</el-table-column>
					<el-table-column label="操作" align="center">
						<template slot-scope="scope">
							<el-button type='text' size="mini" @click="addSingle(scope.row)">添加</el-button>
						</template>
					</el-table-column>
				</el-table>
				<!-- <el-pagination
					@size-change="handleSizeChange"
					@current-change="handlePageChange"
					:current-page="pagination.page"
					:page-sizes="[20,40, 60, 100]"
					:page-size="pagination.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="totalCount">
				</el-pagination> -->
				<div class="valet-foot">
					<!-- <div class="tip-box">选择{{selectNum}}种商品规格，其中赠品有{{giftNum}}种</div> -->
					<el-button class="btn" plain type="primary" size='small' @click="close">取消</el-button>
					<el-button class="btn" plain type="primary" size='small' @click="addMulti">添加</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog :title="dialogTitle" class="dialog-title" :visible.sync="manageModal" width='600px' :close-on-click-modal="false">
			<div style="text-align: left;margin: 10px 0;">
				<el-button size='small' type="primary" style="" plain class='fx-big-btn' @click="addBarcode">新增</el-button>
			</div>
			<div class="bar-wrap">
				<div class="bar-box" v-for="(item, index) in newManageData" :key="item.id">
					<div class="bar-content">
						<el-input type="text" placeholder="最多输入30个字" size='mini' maxlength="30" v-model='item.value'></el-input>
					</div>
					<div class="bar-delete" @click="deleteNew(index)">删除</div>
				</div>
				<div v-for="item in manageData" :key="item.id">
					<div class="bar-box" v-if="item.disabledflag !== 1">
						<div class="bar-content">
							<div>{{item.value}}</div>
						</div>
						<div class="bar-delete" @click="deleteOld(item.id)">删除</div>
					</div>
				</div>
			</div>
			<div class="valet-foot">
				<el-button class="btn" plain type="primary" size='small' @click="closeManage">取消</el-button>
				<el-button class="btn" plain type="primary" size='small' @click="saveManage">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'mainTable',
	props: {
		bigClassList: {
			type: Array
		},
		shopId: {
			type: String
		},
		organid: {
			type: String
		},
		buyersyscodeid: {
			type: String
		},
		acountValue: {
			type: String
		},
		orderobj: {
			type: Object
		},
		afterSaleId: {
			type: String
		},
		detailInfo: {
			type: Object
		},
		address: {
			type: String
		},
		addressType: {
			type: String
		}
	},
	data () {
		return {
			tableHeight: '100%',
			pagination: {
				page: 1,
				size: 20
			},
			dialogVisible: false,
			tipModal: false,
			mergeModel: false,
			manageModal: false,
			curItemData: {},
			tableData: [],
			tableData2: [],
			tipData: [],
			manageData: [],
			newManageData: [],
			errorImgUrl: 'this.src="' + require('$assets/images/img/no-goods-img.png') + '"',
			goodsMoney: '0.00',
			// freight: '0.00',
			totalNum: '0.00',
			totalMoney: '0.00',
			totalOtherMoney: '0.00',
			productName: '',
			bigClass: '',
			smallClass: '',
			smallClassList: [{ name: '全部', id: '' }],
			ids: [],
			totalCount: 0,
			giftNum: 0,
			selectNum: 0,
			selectTableData: [],
			matchbillcenterflag: 1,
			orderNumberRoundRules: null,
			orderdecimalcount: null,
			mergeTip: '',
			manageType: 0,
			dialogTitle: '售后分类管理',
			afterSaleList: [],
			deptList: [],
			dealList: [],
			afterId: ''
		}
	},
	watch: {
		detailInfo (val) {
			this.tableData = val.detail
			this.tableData.forEach(e => {
				e.price = this.$fxUtils.toFixedSHW(e.price, 2)
				e.realMoney = this.$fxUtils.toFixedSHW(e.realMoney, 2)
			})
			this.afterId = val.afterId
			this.calcGoodsMoney()
		}
	},
	created () {
		// this.checkSmallCategory()
		this.getSystemSetting()
		this.getAfterSaleManager()
	},
	methods: {
		// 跳订单
		goOrderDetail () {
			let orderParams = {}
			orderParams.orderId = this.orderobj.orderId || this.orderobj.id
			orderParams.statusId = this.orderobj.statusId
			orderParams.differ = this.orderobj.differ
			orderParams.buypullstate = this.orderobj.buypullstate
			switch (this.orderobj.orderStatus) {
			case 0:
				orderParams.billState = '待付款'
				break
			case 1:
				orderParams.billState = '待接单'
				break
			case 2:
				orderParams.billState = '待发货'
				break
			case 3:
				orderParams.billState = '待收货'
				break
			case 4:
				orderParams.billState = '已完成'
				break
			case 5:
				orderParams.billState = '已取消'
				break
			}
			window.sessionStorage.setItem('orderInfo', JSON.stringify(orderParams))
			let tabInfo = {}
			tabInfo.active = orderParams.billState
			tabInfo.isSellerpull = false
			tabInfo.orderStatus = this.orderobj.orderStatus
			window.sessionStorage.setItem('tabInfo', JSON.stringify(tabInfo))
			this.$fxGoBlank('/blankdetail', this.$router)
		},
		afterFocus (index, id) {
			// this.afterSaleList.forEach(e => {
			// 	if (e.id === id && e.disabledflag === 1) {
			// 		this.tableData[index].afterSaleTypeId = ''
			// 	}
			// })
		},
		afterSaleChange (index, id) {
			this.afterSaleList.forEach(e => {
				if (e.id === id) {
					this.tableData[index].afterSaleTypeValue = e.value
				}
			})
		},
		dealChange (index, id) {
			this.dealList.forEach(e => {
				if (e.id === id) {
					this.tableData[index].dealTypeValue = e.value
				}
			})
		},
		deptChange (index, id) {
			this.deptList.forEach(e => {
				if (e.id === id) {
					this.tableData[index].deptValue = e.value
				}
			})
		},
		// 新增
		addBarcode () {
			let add = { value: '' }
			this.newManageData.push(add)
		},
		showManage (num) {
			this.newManageData = []
			this.manageType = num
			switch (num) {
			case 0:
				this.dialogTitle = '售后分类管理'
				this.manageData = this.afterSaleList
				break
			case 1:
				this.dialogTitle = '责任部门管理'
				this.manageData = this.deptList
				break
			case 2:
				this.dialogTitle = '处理方式管理'
				this.manageData = this.dealList
				break
			}
			this.manageModal = true
		},
		saveManage () {
			if (this.newManageData.length === 0) {
				this.$message.error('当前无新增项')
				return false
			}
			for (let i = 0; i < this.newManageData.length; i++) {
				if (!this.newManageData[i].value) {
					this.$message.error('新增名称不能为空')
					return false
				}
			}
			let arr = this.newManageData.map(e => {
				return e.value
			})
			let data = {
				afterSaleType: this.manageType,
				managerValues: arr
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/saveAfterSaleManagerValue`,
				data: data
			}).then(res => {
				if (res.result) {
					this.getAfterSaleManager()
					this.$message.success('保存成功')
					this.manageModal = false
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		closeManage () {
			this.manageModal = false
		},
		deleteNew (index) {
			this.newManageData.splice(index, 1)
		},
		deleteOld (id) {
			let data = {
				managerValueId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/delAfterSaleManagerValue`,
				data: data
			}).then(res => {
				if (res.result) {
					this.$store.dispatch('requestPost', {
						url: `${this.$fxBaseApi.urlQIVShop}/order/findAllAfterSaleManagerValue`
					}).then(res => {
						if (res.result === true) {
							switch (this.manageType) {
							case 0:
								this.afterSaleList = res.data.afterSaleType
								this.manageData = this.afterSaleList
								this.tableData.forEach(item => {
									if (id === item.afterSaleTypeId) {
										item.afterSaleTypeId = ''
									}
								})
								break
							case 1:
								this.deptList = res.data.dept
								this.manageData = this.deptList
								this.tableData.forEach(item => {
									if (id === item.deptId) {
										item.deptId = ''
									}
								})
								break
							case 2:
								this.dealList = res.data.dealType
								this.manageData = this.dealList
								this.tableData.forEach(item => {
									if (id === item.dealTypeId) {
										item.dealTypeId = ''
									}
								})
								break
							}
						} else {
							this.$message.error(res.msg)
						}
					})
					this.$message.success('删除成功')
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		// 售后分类/责任部门/处理方式
		getAfterSaleManager () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/findAllAfterSaleManagerValue`
			}).then(res => {
				if (res.result === true) {
					this.afterSaleList = res.data.afterSaleType
					this.deptList = res.data.dept
					this.dealList = res.data.dealType
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		numBlur (row) {
			row.itemquantity = +row.itemquantity
		},
		checkNum (row) {
			row.afterSaleQuantity = row.afterSaleQuantity.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			row.afterSaleQuantity = row.afterSaleQuantity.replace(/^\./g, '')// 验证第一个字符是数字而不是
			row.afterSaleQuantity = row.afterSaleQuantity.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			row.afterSaleQuantity = row.afterSaleQuantity.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			switch (this.orderdecimalcount) {
			case 0:
				row.afterSaleQuantity = row.afterSaleQuantity.replace(/[^0-9]/g, '')// 只能输入数字
				break
			case 1:
				row.afterSaleQuantity = row.afterSaleQuantity.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')
				break
			case 2:
				row.afterSaleQuantity = row.afterSaleQuantity.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
				break
			case 3:
				row.afterSaleQuantity = row.afterSaleQuantity.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')
				break
			case 4:
				row.afterSaleQuantity = row.afterSaleQuantity.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3')
				break
			}
		},
		getSystemSetting () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/order/getOrderSystemSetting`
			}).then(res => {
				this.orderNumberRoundRules = res.data.ordermoneyroundrules
				this.orderdecimalcount = res.data.orderdecimalcount
			})
		},
		importExcel () {
			if (this.tableData.length !== 0) {
				this.$confirm('商品信息列表已有数据,不支持批量导入数据,是否删除列表已有数据？', '提示', {
					confirmButtonText: '确认删除',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.tableData = []
					this.goodsMoney = '0.00'
					this.$refs.file.dispatchEvent(new MouseEvent('click'))
				}).catch(() => {
				})
			} else {
				this.$refs.file.dispatchEvent(new MouseEvent('click'))
			}
		},
		// 导入
		getFile (e) {
			this.uploadGoodsHandle()
		},
		uploadGoodsHandle () {
			return new Promise((resolve, reject) => {
				var formData = new FormData()
				formData.append('file', this.$refs.file.files[0])
				formData.append('shopid', this.shopId)
				formData.append('syscodeid', this.buyersyscodeid)
				if (!this.mergeModel) {
					formData.append('action', 0)
				}
				this.$store.dispatch('requestFilePost', {
					url: `${this.$fxBaseApi.newExportUrl}/replacorder/importExcel`,
					data: formData
				}).then(res => {
					if (res.result) {
						this.mergeModel = false
						this.tableData = res.data
						this.$message.success('导入成功！')
						this.calcGoodsMoney()
						this.$refs.file.value = ''
						// this.tableReload()
					} else {
						if (res.code === 0) {
							this.mergeTip = res.data
							this.mergeModel = true
						} else {
							this.tipData = res.data
							this.tipModal = true
						}
						// this.errorMsgList = res.data
						// this.errorMsgModel = true
					}
				})
			})
		},
		// 是否对接中台
		checkSmallCategory () {
			// return new Promise((resolve, reject) => {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.matchbillcenterflag = res.matchbillcenterflag
			})
			// })
		},
		// 计算价格
		calcGoodsMoney () {
			// let price = 0
			let totalNum = 0
			let totalMoney = 0
			let totalOtherMoney = 0
			// let num = 0
			this.tableData.forEach(item => {
				// var quantity = (item.itemquantity * (item.speprice || item.customPrice))
				// item.itemmoney = this.orderNumberRoundRules === 0 ? this.$fxUtils.toFixedSHW(quantity, 2) : this.toFix(quantity)
				// if (!item.giftflag) {
				// 	price += +item.itemmoney
				// }
				totalNum += +item.afterSaleQuantity
				totalMoney += +item.afterSaleMoney
				totalOtherMoney += +item.otherMoney
			})
			this.totalNum = this.$fxUtils.toFixedSHW(totalNum, this.orderdecimalcount, false)
			this.totalMoney = this.$fxUtils.toFixedSHW(totalMoney, 2)
			this.totalOtherMoney = this.$fxUtils.toFixedSHW(totalOtherMoney, 2)
			// this.selectTableData.forEach(item => {
			// 	if (item.giftflag) {
			// 		num++
			// 	}
			// })
			// this.giftNum = num
			// this.goodsMoney = this.orderNumberRoundRules === 0 ? this.$fxUtils.toFixedSHW(price, 2) : this.toFix(price)
		},
		toFix (price) {
			if (+price === 0) {
				return '0.00'
			}
			let num = isNaN(price) ? 0 : price
			num = +num + 0.0000000001
			num = num + ''
			num = num.substring(0, num.indexOf('.') + 3)
			return num
		},
		// 修改售后数量
		quantityInput (e) {
			this.checkNum(e)
			this.calcGoodsMoney()
		},
		quantityBlur (index) {
			if (this.tableData[index].afterSaleQuantity === '') {
				this.tableData[index].afterSaleQuantity = 0
				// this.calcFreight()
			} else {
				this.tableData[index].afterSaleQuantity = +this.tableData[index].afterSaleQuantity
			}
			let money = this.tableData[index].afterSaleQuantity * this.tableData[index].price
			this.tableData[index].afterSaleMoney = this.orderNumberRoundRules === 0 ? this.$fxUtils.toFixedSHW(money, 2) : this.toFix(money)
			this.calcGoodsMoney()
		},
		// 修改售后金额
		afterMoneyInput (row) {
			row.afterSaleMoney = row.afterSaleMoney.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			row.afterSaleMoney = row.afterSaleMoney.replace(/^\./g, '')// 验证第一个字符是数字而不是
			row.afterSaleMoney = row.afterSaleMoney.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			row.afterSaleMoney = row.afterSaleMoney.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			row.afterSaleMoney = row.afterSaleMoney.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
			this.calcGoodsMoney()
		},
		afterMoneyBlur (index) {
			if (this.tableData[index].afterSaleMoney === '') {
				this.tableData[index].afterSaleMoney = 0
				// this.calcFreight()
			} else {
				this.tableData[index].afterSaleMoney = +this.tableData[index].afterSaleMoney
			}
		},
		// 修改额外费用
		otherMoneyInput (row) {
			row.otherMoney = row.otherMoney.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			row.otherMoney = row.otherMoney.replace(/^\./g, '')// 验证第一个字符是数字而不是
			row.otherMoney = row.otherMoney.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			row.otherMoney = row.otherMoney.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			row.otherMoney = row.otherMoney.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
			this.calcGoodsMoney()
		},
		otherMoneyBlur (index) {
			if (this.tableData[index].otherMoney === '') {
				this.tableData[index].otherMoney = 0
				// this.calcFreight()
			} else {
				this.tableData[index].otherMoney = +this.tableData[index].otherMoney
			}
		},
		// 删除商品
		deleteSingle (index) {
			this.tableData.splice(index, 1)
			this.calcGoodsMoney()
			this.$message.success('删除成功')
			// this.calcFreight()
		},
		// 单个添加
		addSingle (item) {
			if (item.itemquantity === '') {
				item.itemquantity = item.minbuycnt === 0 ? 1 : item.minbuycnt
			}
			var itemmoney = item.itemquantity * (item.speprice || item.customPrice)
			item.itemmoney = this.orderNumberRoundRules === 0 ? this.$fxUtils.toFixedSHW(itemmoney, 2) : this.toFix(itemmoney)
			this.tableData.push(item)
			this.search()
			this.calcGoodsMoney()
			// this.calcFreight()
		},
		// 批量添加
		addMulti () {
			let selectData = this.$refs.DataTable.selection
			if (selectData.length === 0) {
				this.$message.error('请选择商品！')
				return false
			}
			selectData.forEach(item => {
				if (item.itemquantity === '') {
					item.itemquantity = item.minbuycnt === 0 ? 1 : item.minbuycnt
				}
				item.itemmoney = this.$fxUtils.toFixedSHW((item.itemquantity * (item.speprice || item.customPrice)), 2)
				this.tableData.push(item)
			})
			this.calcGoodsMoney()
			// this.search()
			// this.calcFreight()
			this.dialogVisible = false
		},
		// 获取小类
		getsmallClass () {
			let data = {
				pid: this.bigClass,
				shopId: this.shopId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: data
			}).then(res => {
				if (res.result) {
					this.smallClass = ''
					let all = { name: '全部', id: '' }
					res.data.unshift(all)
					this.smallClassList = res.data
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		search () {
			let arr = this.tableData.map(e => {
				return e.oipId
			})
			let data = {
				id: this.afterId,
				orderId: this.acountValue,
				productName: this.productName,
				oipIds: arr
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/getOrderDetailForAfterSale`,
				data: data
			}).then(res => {
				if (res.result) {
					res.data.forEach(e => {
						e.selected = false
						e.productmemo = e.memo
						e.memo = ''
						e.price = this.$fxUtils.toFixedSHW(e.price, 2)
						e.realMoney = this.$fxUtils.toFixedSHW(e.realMoney, 2)
					})
					this.tableData2 = res.data
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		clear () {
			this.productName = ''
			this.search()
		},
		selectionChangeHandle (value) {
			let giftNum = 0
			this.selectNum = value.length
			this.selectTableData = value
			let ids = value.map((item) => {
				return item.attrplanid
			})
			for (let i = 0; i < this.tableData2.length; i++) {
				if (ids.indexOf(this.tableData2[i].attrplanid) !== -1) {
					if (this.tableData2[i].giftflag) {
						giftNum++
					}
					this.tableData2[i].selected = true
					if (this.tableData2[i].itemquantity === '') {
						this.tableData2[i].itemquantity = this.tableData2[i].minbuycnt === 0 ? 1 : this.tableData2[i].minbuycnt
					}
				} else {
					this.tableData2[i].selected = false
				}
			}
			this.giftNum = giftNum
		},
		addGoods () {
			let data = {
				orderNumber: this.orderobj.orderNumber
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/refundorder/findWaitDealRefundOrder`,
				data: data
			}).then(res => {
				if (res.result) {
					if (res.data.length > 0) {
						this.$confirm('当前订单有' + res.data.length + '条待处理的订单,是否继续？', '提示', {
							distinguishCancelAndClose: true,
							confirmButtonText: '继续添加商品',
							cancelButtonText: '查看退单',
							type: 'warning',
							closeOnClickModal: false
						}).then(() => {
							this.dialogVisible = true
						}).catch(action => {
							if (action === 'cancel') {
								if (res.data.length > 1) {
									let num = new Date(res.data[0].refundordercreatedate).getTime()
									let date = res.data[0].refundordercreatedate
									res.data.forEach(e => {
										if (num > new Date(e.refundordercreatedate).getTime()) {
											date = e.refundordercreatedate
										}
									})
									this.$router.push({ path: '/main/refundOrder', query: { ordernumber: this.orderobj.orderNumber, date: date } })
								} else if (res.data.length === 1) {
									let a = JSON.stringify(res.data[0])
									window.sessionStorage.setItem('refundOrderParams', a)
									this.$router.push({ path: 'refundOrderDetail' })
								}
							}
						})
					} else {
						this.dialogVisible = true
					}
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		handleSizeChange (value) {
			this.pagination.size = value
			this.search()
		},
		handlePageChange (value) {
			this.pagination.page = value
			this.search()
		},
		dialogClose () {
			this.tableData2 = []
			// this.pagination.page = 1
			// this.bigClass = ''
			// this.smallClass = ''
			this.productName = ''
			// this.getsmallClass()
			// this.smallClassList = [{ shopCategoryName: '全部', id: '' }]
		},
		close () {
			this.dialogVisible = false
		},
		handleMergeClick (val) {
			if (val === 'cancel') {
				this.$refs.file.value = ''
				this.mergeModel = false
				this.$refs.file.dispatchEvent(new MouseEvent('click'))
			} else if (val === 'merge') {
				this.uploadGoodsHandle()
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.main-table1 {
	display flex
	// flex: 1
	flex-direction: column
	// height: 100%
	padding-left: 10px
	font-size: 14px
	margin-top: 10px
	text-align: left
	.fx-title {
		font-weight: 700
		margin: 10px 0 10px 0
	}
	.main-table-box {
		flex: 1
		padding-bottom 10px
		overflow-y: auto;
		.valet-add-btn {
			margin: 10px 10px 10px 0
		}
		.shop-info{
			display: flex
			justify-content: center;
		}
	}
	.goods-total {
		display: flex
		flex-direction: column
		justify-content: flex-end
		padding-left: 60%
		margin: 20px 0
		&>div {
			margin: 3px 0
			&>span {
				display: inline-block
				width: 130px;
				text-align: right
			}
		}
		.el-input {
			width: 100px
		}
	}
	.batch-register-btn{
		cursor :pointer;
		color: var(--fx-primary-color);
		font-size: 12px;
		margin: 10px;
		margin-left: 0;
		width: 100px;
		height: 32px;
		display: flex;
		align-items: center;
		justify-content: center
	}
	.excel-icon {
		display inline-block
		height 20px
		width 20px
		background-repeat no-repeat
		background-position center
		&.import-excel-icon {
			background-image: url('~images/icon/import-excel-icon.png')
		}
		&.export-excel-icon {
			background-image: url('~images/icon/export-excel-icon.png')
		}
	}
}
</style>
<style lang="stylus">
	.pname-box {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		div {
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 3;
			overflow: hidden;
		}
	}
	.giftLogo{
		margin-right :5px;
		font-size :10px;
		width: 34px;
		height: 18px;
		line-height: 18px;
		color: var(--fx-primary-color);
		border: 1px solid var(--fx-primary-color);
		border-radius :5px;
		flex-shrink: 0
	}
	.red-class .el-input__inner {
		color: red;
	}
.spec-title {
	width: 14px;
	height: 14px;
	position: absolute;
	top: 4px;
	right: 15px;
	cursor: pointer
}
.head-add {
	color: var(--fx-primary-color);
	text-decoration: underline;
	margin-left:5px;
	cursor: pointer
}
.main-table1 {
	.bar-wrap {
		max-height: 300px;
		overflow-y: auto;
		.bar-box {
			display: flex;
			align-items: center;
			padding-right: 20px;
			line-height: 20px;
			margin-bottom: 15px;
			.bar-content {
				flex: 1;
				padding: 0 20px
			}
			.bar-delete {
				margin-left: auto;
				flex-shrink: 0;
				text-decoration: underline;
				color: var(--fx-primary-color);
				cursor: pointer;
				font-size: 13px
			}
		}
	}
	.el-dialog {
		margin-top: 25vh !important
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px;
		padding-bottom: 10px;
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-pagination {
		text-align: center;
		margin-top: 10px
	}
	.valet-foot {
        height :40px;
        margin-top: 10px;
		text-align: center
		position :relative
        .btn{
            width :120px;
			height :35px;
			margin: 0 30px
        }
		.tip-box{
			position :absolute;
			width:400px;
			bottom :8px;
			text-align :left;
			left :750px;
			color :#999999
		}
	}
	.el-radio {
		margin-right: 20px;
		&:last-child {
			margin-right: 0
		}
	}
	.btn-box {
		display flex
		justify-content: center
		.el-button {
			width: 120px
		}
	}
	.filters-container {
		margin-right: 15px
		display: flex
		margin-bottom: 10px
		line-height: 19px;
		&:last-of-type {
			margin-bottom: 20px
		}
		.order-code {
			cursor:pointer;
			text-decoration: underline;
			color: var(--fx-primary-color);
		}
		.input-box {
			margin-right: 20px
		}
		.el-input {
			width: 240px
		}
		.filter-input {
			width: 160px;
		}
	}
}
</style>
